// src/components/HomeCarousel.tsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const projects = [
    // { "image": "./images/home carosuel/carol1.webp", "legend": "Legend 1" },
    { "image": "./images/home carosuel/carol2.webp", "legend": "Legend 2" },
    { "image": "./images/home carosuel/carol12.webp", "legend": "Legend 12" },
    { "image": "./images/home carosuel/carol3.webp", "legend": "Legend 3" },
    { "image": "./images/home carosuel/carol4.webp", "legend": "Legend 4" },
    { "image": "./images/home carosuel/carol5.webp", "legend": "Legend 5" },
    { "image": "./images/home carosuel/carol6.webp", "legend": "Legend 6" },
    { "image": "./images/home carosuel/carol7.webp", "legend": "Legend 7" },
    { "image": "./images/home carosuel/carol8.webp", "legend": "Legend 8" },
    { "image": "./images/home carosuel/carol9.webp", "legend": "Legend 9" },
    // { "image": "./images/home carosuel/carol12.webp", "legend": "Legend 10" },
];


function HomeCarousel() {
  return (
    <section className="py-16 bg-gray-50 animate-motion" id="latest-projects">
      <div className="max-w-7xl mx-auto px-6 animate-motion">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 my-3 animate-motion">
          Inside Ghazipur’s Most {" "}
          <span className="text-[#0097b2]">
            {" "}
           Trusted Learning Hub
          </span>
        </h2>
        <p className="text-gray-600 mb-10 animate-motion">
          Discover how SSS Achievers empowers students with discipline, direction, and determination.
        </p>

        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={30}
          slidesPerView={3}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="animate-motion"
        >
          {projects.map((project, index) => (
            <SwiperSlide key={index} className="animate-motion">
              <div className="relative group rounded-lg overflow-hidden shadow-lg hover:animate-motion animate-motion">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-[500px] object-cover transition-transform duration-500 group-hover:scale-105 animate-motion"
                  required
                />
                {/* <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-motion">
                  <span className="text-yellow-400 text-sm font-semibold mb-2 animate-motion">
                    {project.label}
                  </span>
                  <h3 className="text-white text-lg font-bold mb-1 animate-motion">
                    {project.title}
                  </h3>
                  <p className="text-gray-200 text-sm animate-motion">
                    {project.description}
                  </p>
                </div> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default HomeCarousel;
